export default __webpack_public_path__ + "static/pdf-69fa87d157977a339e0a34cf7a72c4b5.svg";